import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";

import LookupTable from "@/components/membership/ChooseFormulaModal/lookupForm/LookupTable/LookupTable";

const LookupForm = ({
  lookupColumns,
  updateLookupColumns,
  tableValues,
  updateTableValues,
  setDisableContinueButton,
  permittedOutputs,
  alterTable,
  updateFullTable,
}) => {
  const [errors, setErrors] = useState({
    blankColumns: false,
    blankOutputs: false,
    duplicateRows: false,
    multipleRowsSameOutput: false,
    invalidCSV: false,
  });
  const [activeErrors, setActiveErrors] = useState([]);

  const updateErrors = (errorType, hasError) => {
    setErrors((prev) => ({
      ...prev,
      [errorType]: hasError
        ? (prev[errorType] = true)
        : Math.max(0, (prev[errorType] = false)),
    }));
  };

  const errorMessages = {
    blankColumns: "Please ensure all the column names are mapped",
    blankOutputs: "Please ensure there are no blank OUTPUTS",
    duplicateRows: "Please remove all duplicate rows",
    multipleRowsSameOutput:
      "There are multiple rows matching the same inputs to different outputs.",
    invalidCSV: "Invalid CSV",
  };

  useEffect(() => {
    const currentActive = Object.entries(errors)
      .filter(([_, hasError]) => hasError)
      .map(([type]) => errorMessages[type]);

    setActiveErrors(currentActive);
    // errorMessages is a module-local object defined on every render;
    // including it would cause the effect to re-fire continuously.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (activeErrors.length > 0) {
      setDisableContinueButton(true);
    } else {
      setDisableContinueButton(false);
    }
  }, [activeErrors, setDisableContinueButton]);

  return (
    <>
      {activeErrors.length > 0 && (
        <Alert severity="error" sx={{ marginBottom: "10px" }}>
          {activeErrors.map((error) => (
            <Box key={error}>{error}</Box>
          ))}
        </Alert>
      )}
      <LookupTable
        lookupColumns={lookupColumns}
        updateLookupColumns={updateLookupColumns}
        tableValues={tableValues}
        updateTableValues={updateTableValues}
        permittedOutputs={permittedOutputs}
        updateErrors={updateErrors}
        alterTable={alterTable}
        updateFullTable={updateFullTable}
      />
    </>
  );
};

export default LookupForm;
